import { render, staticRenderFns } from "./EditHot.vue?vue&type=template&id=3aa0c989&scoped=true&"
import script from "./EditHot.vue?vue&type=script&lang=js&"
export * from "./EditHot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa0c989",
  null
  
)

export default component.exports